import React from 'react';
import { MapPin } from 'lucide-react';
export function FarmingtonHillsDistance() {
  return <section className="bg-charcoal text-white py-6" data-id="element-1201">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-center gap-3" data-id="element-1202">
        <MapPin className="w-6 h-6 text-storm-red" data-id="element-1203" />
        <span className="text-lg font-bold uppercase tracking-wide" data-id="element-1204">
          Right here in your community
        </span>
      </div>
    </section>;
}